import * as React from 'react';
import { FormikProps } from 'formik';
import { formErrorKey } from './form';
import ErrorMessage from '../../../commonComponents/ErrorMessage';

const FormError = ({ formikProps }: Props) => {
	return Object.keys(formikProps.touched).length > 0 && formikProps.errors[formErrorKey] ? (
		<ErrorMessage message={formikProps.errors[formErrorKey] as string} />
	) : null;
};

interface Props {
	formikProps: FormikProps<FormErrorValues>;
}

export default FormError;

export interface FormErrorValues extends Record<string, unknown> {
	[formErrorKey]: string;
}
